import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBookingReference, IBookingReferenceState } from "./bookingReferenceModel";
import { getAllBookingReference } from "./services/bookingReference.services";

const initialState: IBookingReferenceState = {
  loading: false,
  error: "",
  BookingReferenceList: [],
  FilterBookingReference: {
    RoomName: "",
  },
};

const bookingReferenceSlice = createSlice({
  name: "bookingReference",
  initialState,
  reducers: {
    setFilterBookingReference: (state, action) => {
      state.FilterBookingReference = action.payload;
    },
    clearFilterBookingReference: (state) => {
      state.FilterBookingReference = initialState.FilterBookingReference;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllBookingReference.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBookingReference.fulfilled,
      (state, action: PayloadAction<IBookingReference[]>) => {
        state.loading = false;
        state.BookingReferenceList = action.payload || [];
      }
    );
    builder.addCase(getAllBookingReference.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BookingReferenceList = [];
    });
  },
});

export const {
  clearFilterBookingReference,
  setFilterBookingReference,
} = bookingReferenceSlice.actions;
export default bookingReferenceSlice.reducer;
